import { Badge, NodeLogo } from '@hevoio/hevo-ui-toolkit';
import type { NodeLogoProps } from '@hevoio/hevo-ui-toolkit';
import clsx from 'clsx';
import React, { ReactNode } from 'react';
import { HdIcon, HdTooltip } from '../../../../components';
import styles from './GenericListItemContent.module.scss';


export interface GenericListItemContentProps {
  suffixIcon?: string;
  suffixIconBadge?: string;
  canUseEnterpriseLogo?: boolean;
  primaryText: ReactNode;
  primaryTooltipText?: ReactNode;
  primaryTextClass?: string;
  primaryLogoProps?: NodeLogoProps;
  primaryLogoTooltip?: string;
  secondaryText?: ReactNode;
  secondaryTooltipText?: string;
  secondaryLogoProps?: NodeLogoProps;
  secondaryLogoTooltip?: string;
  secondaryTextClass?: ReactNode;
  logoConnector?: boolean;
  logoConnectorColor?: string;
}

export function GenericListItemContent({
  suffixIcon,
  suffixIconBadge,
  primaryText,
  primaryTooltipText,
  primaryTextClass,
  primaryLogoProps,
  primaryLogoTooltip,
  secondaryText,
  secondaryTextClass,
  logoConnector,
  logoConnectorColor,
  secondaryLogoProps,
  secondaryLogoTooltip,
  secondaryTooltipText,
  canUseEnterpriseLogo
}: GenericListItemContentProps) {
  return (
    <>
      {suffixIcon ? (
        <div className='center-flex-col justify-center position-relative'>
          <HdIcon className='text-secondary' name={suffixIcon} />

          {suffixIconBadge ? (
            <Badge
              badgeContent={suffixIconBadge}
              compact
              classes={{ badge: styles.badge }}
            />
          ) : null}
        </div>
      ) : null}

      <div className={clsx('w-40 text-ellipsis ml-3 mr-5', primaryTextClass)}>
        <HdTooltip title={primaryTooltipText ?? primaryText} enableOnTextOverflow>
          <span className='d-block text-medium'>
            {primaryText}
          </span>
        </HdTooltip>
      </div>

      {primaryLogoProps ? (
        <HdTooltip title={primaryLogoTooltip}>
          <span>
            <NodeLogo
              className='border-radius-md'
              size={2}
              roundedBorders={false}
              withContextualBg={canUseEnterpriseLogo}
              {...primaryLogoProps}
            />
          </span>
        </HdTooltip>
      ) : null}

      {logoConnector ? (
        <HdIcon
          name='pipeline-connection'
          className={clsx(styles.logoConnectionIndicator, `text-${logoConnectorColor}`)}
        />
      ) : null}

      {secondaryLogoProps ? (
        <HdTooltip title={secondaryLogoTooltip}>
          <span>
            <NodeLogo
              className='border-radius-md'
              size={2}
              roundedBorders={false}
              withContextualBg={canUseEnterpriseLogo}
              {...secondaryLogoProps}
            />
          </span>
        </HdTooltip>
      ) : null}

      {secondaryText ? (
        <HdTooltip title={secondaryTooltipText ?? secondaryText} enableOnTextOverflow>
          <span className={clsx('text-ellipsis text-normal ml-2', secondaryTextClass)}>
            {secondaryText}
          </span>
        </HdTooltip>
      ) : null}
    </>
  );
}
